import { useTranslation } from "react-i18next";

import "./TermsConditions.css";

const TermsConditions = () => {
	const { t } = useTranslation();
	const items = t("terms-conditions.paragraphs", { returnObjects: true });

	return (
		<div className="terms-conditions-bg">
			<h1 className="terms-conditions-title">{t("terms-conditions.title")}</h1>

			<div className="terms-conditions-content">
				{items.map((item, index) => {
					if (item["style"] === "br") {
						return <br key={index} />;
					} else if (item["style"] === "bold") {
						return (
							<div
								key={index}
								className={`terms-conditions-text-` + item["style"]}
							>
								<h5 className="terms-conditions-text">{item["text"]}</h5>
							</div>
						);
					} else {
						return <h5 className="terms-conditions-text">{item["text"]}</h5>;
					}
				})}
			</div>
		</div>
	);
};

export default TermsConditions;
